import React from 'react';
import PropTypes from 'prop-types';
import FinancialProductDetailsCard from './FinancialProductDetailsCard';

const FinancialProductDetailsContainer = ({ canWrite, data, productId, isSaved, generalDataLens }) => {
  return <FinancialProductDetailsCard canWrite={canWrite} data={data} productId={productId} isSaved={isSaved} generalDataLens={generalDataLens} />;
};

FinancialProductDetailsContainer.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  data: PropTypes.object,
  productId: PropTypes.number.isRequired,
  isSaved: PropTypes.bool.isRequired,
  generalDataLens: PropTypes.object.isRequired
};

export default FinancialProductDetailsContainer;
